// @flow

export const BORDER_WIDTH_1 = '1px';
export const BORDER_WIDTH_2 = '2px';
export const BORDER_WIDTH_3 = '3px';



// WEBPACK FOOTER //
// ./src/styles/borders.js